module.exports = __webpack_public_path__ + "img/img_mobile_occupation_jian.32bb1e3f.jpg";